var _g, _ellipse, _ellipse2, _path, _path2, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgStartOverIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 38,
    height: 41,
    viewBox: "0 0 38 41",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2949_2995)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 4.5791,
    y: 8.73059,
    width: 21.4905,
    height: 26.1916,
    fill: "#5A52C3"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_2949_2995)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip2_2949_2995)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M23.1064 4.95351H19.2335V3.80198C19.2335 3.25687 18.7915 2.8149 18.2464 2.8149H17.6764C17.5653 1.24365 16.277 0 14.7095 0C13.1789 0 11.8738 1.2651 11.7452 2.8149H10.679C10.1339 2.8149 9.6919 3.25687 9.6919 3.80198V4.95351H6.31251C3.52082 4.95351 1.21973 7.18974 1.21973 9.98143V33.634C1.21973 35.8236 3.03095 37.6084 5.22054 37.6084H24.1983C26.3879 37.6084 28.1991 35.8236 28.1991 33.634V9.98143C28.1992 7.18974 25.8981 4.95351 23.1064 4.95351ZM24.3333 32.6732C24.3333 33.1275 23.965 33.4957 23.5107 33.4957H5.90829C5.45398 33.4957 5.08575 33.1275 5.08575 32.6732V10.2178C5.08575 9.7635 5.45398 9.39527 5.90829 9.39527H23.5107C23.965 9.39527 24.3333 9.7635 24.3333 10.2178V32.6732Z",
    fill: "#5A52C3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.1064 4.95351H19.2335V3.80198C19.2335 3.25687 18.7915 2.8149 18.2464 2.8149H17.6764C17.5653 1.24365 16.277 0 14.7095 0C13.1789 0 11.8738 1.2651 11.7452 2.8149H10.679C10.1339 2.8149 9.6919 3.25687 9.6919 3.80198V4.95351H6.31251C3.52082 4.95351 1.21973 7.18974 1.21973 9.98143V33.634C1.21973 35.8236 3.03095 37.6084 5.22054 37.6084H24.1983C26.3879 37.6084 28.1991 35.8236 28.1991 33.634V9.98143C28.1992 7.18974 25.8981 4.95351 23.1064 4.95351ZM24.3333 32.6732C24.3333 33.1275 23.965 33.4957 23.5107 33.4957H5.90829C5.45398 33.4957 5.08575 33.1275 5.08575 32.6732V10.2178C5.08575 9.7635 5.45398 9.39527 5.90829 9.39527H23.5107C23.965 9.39527 24.3333 9.7635 24.3333 10.2178V32.6732Z",
    stroke: "#5A52C3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.6309 9.40222H16.3397V18.1328H13.6309V9.40222Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.6211 12.4136H19.3516V15.1223H10.6211V12.4136Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 8.60645,
    y: 30.2211,
    width: 12.76,
    height: 2.01474,
    rx: 1.00737,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 8.60645,
    y: 25.52,
    width: 12.76,
    height: 2.01474,
    rx: 1.00737,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 8.60645,
    y: 20.819,
    width: 12.76,
    height: 2.01474,
    rx: 1.00737,
    fill: "white"
  }))))), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 27.1169,
    cy: 32,
    rx: 9.11688,
    ry: 9,
    fill: "#8C86DF"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 28.1169,
    cy: 32,
    rx: 9.11688,
    ry: 9,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M28.4166 31.6966L28.4166 28.481C28.4168 28.3137 28.2826 28.1778 28.1174 28.1779C27.9521 28.1779 27.8182 28.3135 27.8182 28.481L27.8183 31.6966L24.6439 31.6966C24.4786 31.6966 24.3447 31.8322 24.3447 31.9996C24.3446 32.167 24.4787 32.3029 24.6439 32.3027L27.8183 32.3027L27.8183 35.5184C27.8182 35.6857 27.9523 35.8216 28.1175 35.8214C28.2002 35.8214 28.2749 35.7874 28.3291 35.7326C28.3833 35.6777 28.4167 35.6021 28.4167 35.5184L28.4167 32.3027L31.591 32.3028C31.6737 32.3028 31.7485 32.2688 31.8026 32.2139C31.8568 32.159 31.8902 32.0834 31.8902 31.9997C31.8904 31.8324 31.7562 31.6965 31.591 31.6966L28.4166 31.6966Z",
    fill: "#5A52C3"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M28.4166 31.6966L28.4166 28.481C28.4168 28.3137 28.2826 28.1778 28.1174 28.1779C27.9521 28.1779 27.8182 28.3135 27.8182 28.481L27.8183 31.6966L24.6439 31.6966C24.4786 31.6966 24.3447 31.8322 24.3447 31.9996C24.3446 32.167 24.4787 32.3029 24.6439 32.3027L27.8183 32.3027L27.8183 35.5184C27.8182 35.6857 27.9523 35.8216 28.1175 35.8214C28.2002 35.8214 28.2749 35.7874 28.3291 35.7326C28.3833 35.6777 28.4167 35.6021 28.4167 35.5184L28.4167 32.3027L31.591 32.3028C31.6737 32.3028 31.7485 32.2688 31.8026 32.2139C31.8568 32.159 31.8902 32.0834 31.8902 31.9997C31.8904 31.8324 31.7562 31.6965 31.591 31.6966L28.4166 31.6966",
    stroke: "#5A52C3",
    strokeWidth: 1.5
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2949_2995"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 29,
    height: 38.28,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_2949_2995"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 37.6084,
    height: 37.6084,
    fill: "white",
    transform: "translate(-4.15234)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip2_2949_2995"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 37.6084,
    height: 37.6084,
    fill: "white",
    transform: "translate(-4.15332)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStartOverIcon);
export default __webpack_public_path__ + "static/media/startOverIcon.e4438973f7a5e1e96ce6eaa791388e27.svg";
export { ForwardRef as ReactComponent };